// extracted by mini-css-extract-plugin
module.exports = {"root":"B_bY","item":"B_1","item-img":"B_cq","itemImg":"B_cq","grid-item-title":"B_cr","gridItemTitle":"B_cr"};